import { MutationPayload } from './mutation-payload';

export interface DeleteProjectCommitteeResult {
  deleteProjectCommittee: DeleteProjectCommitteePayload;
}

export interface DeleteProjectCommitteePayload extends MutationPayload {
  _empty?: boolean; // An empty(dummy) field since the keeping the interface empty raises a warning.
}
